import { fpLocationMarkerFactory } from './FpLocationMarker';
import IconWithHighlight, {
    UnthemedIconWithHighlight
} from 'common/components/core/markers/IconWithHighlight';

const FpMarkerWithHighlightFactory = (components, options) => {
    const { themed = true } = options || {};
    return fpLocationMarkerFactory({
        ...components,
        Icon: themed ? IconWithHighlight : UnthemedIconWithHighlight,
        options
    });
};

export default FpMarkerWithHighlightFactory;
